import { Environment } from './environment.type';

export const environment: Environment = {
  production: false,
  stage: 'development',
  oidc: {
    authority: 'https://dev-cardinal.eshava.de',
    audience: 'https://dev-ascent.eshava.de',
    clientId: 'Eshava.UI.Angular.Ascent-Dev',
    requireHttps: true,
    scope: 'openid profile email offline_access services.api.read'
  },
  baseUrls: {
    ascentUrl: 'https://dev-api.eshava.de/ascent',
    cardinalUrl: 'https://dev-cardinal.eshava.de',
    uiUrl: 'https://dev-ascent.eshava.de'
  }
};
